import { useState, useEffect, useRef } from 'react';
import VectorPng from '../../../../assets/Survey/Vector.png';
import VectorSvg from '../../../../assets/Survey/Vector.svg';
import VectorSvgDark from '../../../../assets/Survey/Survey Vector Dark.svg';
import { isMacOS } from './../../../../utils/isMacOS';
import { isFirefox } from './../../../../utils/isFirefox';
import { useTheme } from '../../../../context/ThemeContext';
import SurveyQuiz from '../SurveyQuiz/SurveyQuiz';
import "./FuneralSurvey.css"

const FuneralSurvey = props => {
  const { theme } = useTheme();
  const [closing, setClosing] = useState(false);
  const tRef = useRef();
  const vectorSrc = theme === 'dark' ? VectorSvgDark : VectorSvg;

  // when it becomes visible again, clear closing flag
  useEffect(() => {
    if (props.visible) setClosing(false);
    return () => clearTimeout(tRef.current);
  }, [props.visible]);

  const handleClose = (e) => {
    e.preventDefault();
    if (closing) return;          // guard double clicks
    setClosing(true);             // start CSS out-animation
    tRef.current = setTimeout(() => {
      props.close();              // actually hide/unmount after animation
      setClosing(false);          // (in case it remains mounted)
    }, 240);
  };
    
  return (
    <div className={`funeralSurvey ${props.visible ? 'active' : ''} ${props.desktop ? "desktop" : ""} ${closing ? "closing" : ""}`}>
        <div className="d-flex align-items-center justify-content-between mb-12">
          <div className="d-flex flex-column addYourVoiceWrapper mx-mdxl-auto">
            <img src={!isMacOS() && isFirefox() ? VectorPng : vectorSrc} className="titleIcon align-self-end" alt="" />
            <h4>Add your voice</h4>
          </div>
        </div>

        {<div className="infoText mb12">While you’re comparing these policies, we invite you take part in our 30-second survey.</div>}

        {<div className={`infoText mb20 font-weight-500`}>Recently dealt with funeral expenses? Your feedback will help us expose the costs real consumers endure in paying for a funeral.</div>}

        <SurveyQuiz {...props} desktop={props.desktop} />

        <div className={`surveyNote ${props.desktop ? "noteDesktop" : "noBackground"}`}>This information may be used for data in our articles, but will never be publicly linked to you.</div>
    </div>
  );
};

export default FuneralSurvey;
